module.exports = __webpack_public_path__ + "static/ucsdLogo-914f5b55ea697489d45b031bec3ecaa5.png";